module.exports = __webpack_public_path__ + "img/fitness-boost-logo.d47547f8.png";